import script from "./Balances.vue?vue&type=script&setup=true&lang=js"
export * from "./Balances.vue?vue&type=script&setup=true&lang=js"

import "./Balances.vue?vue&type=style&index=0&id=7d131130&scoped=true&lang=css"
script.__scopeId = "data-v-7d131130"

export default script